import Filter from 'bad-words';

export const filterBadWords = text => {
  const filter = new Filter();
  return text && filter.clean(text);
};
